var globals = {};

globals.genders = ["Male", "Female", "Other", "Undisclosed"];
globals.grades = ["PreK", "K", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "Adult"],
globals.states = ["AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY", "DC"];
globals.referredBySources = ["Friends/Family", "Event Booth", "Web Search", "Online Promotion", "Facebook", "Newspaper/Magazine", "TV/Media", "Flyer", "Other"];

globals.relationships = ["Mom", "Dad", "Sister", "Brother", "Uncle", "Aunt", "Grandma", "Grandpa", "Cousin"];

globals.phoneTypes = ["Home", "Mobile", "Work", "Other"];

export default globals
